'use client';

import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import Campaign from '@components/cards/Campaign/Campaign';
import { FlexibleDiv } from '@components/formStyles';
import Breadcrumb from '@components/Breadcrumb/Breadcrumb';
import { BreadCrumbListSchemaOrg } from '@utils/schemaorg/BreadCrumbListSchemaOrg';
import { StaticPageSchemaOrg } from '@utils/schemaorg/StaticPageSchemaOrg';
import { callService } from '@api/remote-call';

import { ContentWrapper, Container, Items } from '../styled';
import CampaignsSkeleton from '../CampaignsSkeleton';
import ErrorPage404 from '../../error/ErrorPage404';

const CampaignsLanding = () => {
  const params = useParams();

  // ======================================
  // Fetch the initial campaign items
  // ======================================
  const {
    data,
    isError,
    isLoading: loadingItems,
  } = useQuery(['campaignLanding'], () =>
    callService(
      { service: 'ContentsService', method: 'getCampaigns', version: 'v3' },
      {
        slug: params?.slug as string,
      }
    )
  );
  const breadItems = useMemo(() => {
    const itemTitle = data?.title;

    return [
      {
        title: 'Ana Sayfa',
        url: '/',
      },
      {
        title: itemTitle || '',
        url: `/${params?.slug}`,
      },
    ];
  }, [params, data]);
  if (isError) return <ErrorPage404 />;

  return (
    <>
      {data?.title && data?.text ? (
        <StaticPageSchemaOrg name={data?.title} description={data?.text} />
      ) : null}
      <Container>
        {loadingItems ? (
          <CampaignsSkeleton />
        ) : (
          <ContentWrapper>
            <FlexibleDiv top={40} bottom={18}>
              <BreadCrumbListSchemaOrg data={breadItems || []} />
              <Breadcrumb items={breadItems} />
            </FlexibleDiv>

            <Items>
              {data?.items?.map((item) => (
                <Campaign
                  name={item.name}
                  url={item.url}
                  key={item.name}
                  subText={item.subText || ''}
                  images={item.images}
                  icons={item.icons}
                />
              ))}
            </Items>
          </ContentWrapper>
        )}
      </Container>
    </>
  );
};

export default CampaignsLanding;
